import type { paymentMethods } from '@dovefiniscono/shared';

export type PaymentMethod = (typeof paymentMethods)[number];

/** How a movement was paid, in the order the dialog offers them. */
export const PAYMENT_METHODS: { value: PaymentMethod; label: string }[] = [
  { value: 'cash', label: 'Contanti' },
  { value: 'card', label: 'Carta' },
  { value: 'transfer', label: 'Bonifico' },
];

export const methodLabel = new Map<string, string>(
  PAYMENT_METHODS.map((method) => [method.value, method.label.toLowerCase()]),
);

// How and with whose money are separate choices, but they usually go together: cash comes from the
// cash account, a card or a transfer from a bank account. Money paid by others is left alone.

/** The method that goes with an account just chosen. */
export function methodFor(
  accountKind: string | undefined,
  current: PaymentMethod | '',
): PaymentMethod | '' {
  if (accountKind === 'cash') return 'cash';
  if (accountKind === 'card') return 'card';
  if (accountKind === 'bank' && current === 'cash') return 'card';
  return current;
}

/** The account that goes with a method just chosen, or null to keep the current one. */
export function accountFor(
  method: PaymentMethod,
  currentKind: string | undefined,
  own: readonly { id: string; kind: string }[],
): string | null {
  if (currentKind === 'external') return null;
  if (method === 'cash' && currentKind !== 'cash') {
    return own.find((account) => account.kind === 'cash')?.id ?? null;
  }
  if (method !== 'cash' && currentKind === 'cash') {
    return own.find((account) => account.kind === 'bank' || account.kind === 'card')?.id ?? null;
  }
  return null;
}
